import { getSequencesTemplates } from '@/services/sequencesService';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { useSequencesContext } from '../SequencesContext';
import type { StepsType } from './useSequences';

export type TemplatesType = {
	id?: string;
	name?: string;
	description?: string;
	default?: boolean;
	isAiGenerated?: boolean;
	steps: StepsType[];
};

export function useTemplates() {
	const { templates, setTemplates } = useSequencesContext();

	const [isLoading, setIsLoading] = useState(false);

	function getTemplates() {
		setIsLoading(true);
		getSequencesTemplates()
			.then(res => {
				if (res.status !== 200) {
					throw new Error(
						'There was an error getting templates. Please try again later.'
					);
				}
				if (res.data) {
					setTemplates(res.data.data.campaigns);
				}
			})
			.catch(err => {
				toast.error(err.message);
			})
			.finally(() => {
				setIsLoading(false);
			});
	}

	return {
		templates,
		getTemplates,
		isLoading
	};
}
